import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCSMTeachersGetAll } from '../../../api/csm';
import { FlexView, Row, Separator } from '@cuemath/comps';
import { Table, TableCell } from 'comps';
import Search from 'modules/list/new-search-bar';
import { TableRow } from 'semantic-ui-react';
import Pagination from 'modules/list/pagination';
import styled, { keyframes } from 'styled-components';
import { Text } from '@cuemath/web-comps';

const StyledTableCell = styled(TableCell)`
  cursor: pointer;
`;
const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const Container = styled(FlexView)`
  padding: 0 16px;
  animation: ${FadeIn} 0.5s ease-in-out;
`;
const PaginationWrapper = styled(Row)`
  height: 42px;
`;
const TableWrapper = styled(Row)`
  margin-top: 24px;
  width: 100%;
`;

const CsmAssignedTeachers = () => {
  const { csmId } = useParams();
  const [page, setPage] = useState(1);
  const [searchVal, setSearchVal] = useState('');

  const {
    data: csmTeachers,
    getAll: csmTeachersGetAll,
    isProcessing: isTeachersLoading,
  } = useCSMTeachersGetAll();

  const fetchTeachersList = useCallback(() => {
    const query = {
      csmId,
      page,
      search: searchVal,
      per_page: 10,
    };
    if (!searchVal) delete query.search;
    csmTeachersGetAll(query);
  }, [csmId, page, searchVal]);

  useEffect(() => {
    fetchTeachersList();
  }, [fetchTeachersList]);

  const handlePageChange = useCallback(newPage => {
    setPage(newPage);
  }, []);

  const handleSearch = useCallback(val => {
    setPage(1);
    setSearchVal(val);
  }, []);

  const showPagination = csmTeachers?.length > 0;

  return (
    <Container>
      <Row justifyContent="flex-end">
        <Search
          showNewSearchBar={true}
          onSearch={handleSearch}
          placeholder="Search teachers by ID"
        />
      </Row>
      <TableWrapper>
        <Table
          headerCell={[{ title: 'Name' }, { title: 'Email' }]}
          dataLength={csmTeachers?.length || 0}
          havePagination
          showInfo={false}
          showLoader={isTeachersLoading}
          flexBasis="100%"
          scrollBodyHeight={isTeachersLoading || !showPagination ? '532px' : '100%'}
        >
          {csmTeachers?.map(({ id, name, email }) => (
            <TableRow key={id}>
              <StyledTableCell
                onClick={() => window.open(`/users/teachers/${id}`, '_blank')}
                width={4}
              >
                {name}
              </StyledTableCell>
              <TableCell width={4}>
                <Text variant="body2">{email}</Text>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableWrapper>
      <Separator transparent height={8} />
      <PaginationWrapper justifyContent="center" alignItems="center">
        {showPagination && (
          <Pagination
            page={page}
            perPage={10}
            count={null}
            onPageChange={handlePageChange}
            shouldShowNewUi
          />
        )}
      </PaginationWrapper>
    </Container>
  );
};

export default CsmAssignedTeachers;
